import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import * as actionTypes from 'store/action-types';
import AuthService from 'shared/services/auth.service';
import httpService from 'shared/services/http.service';
import { createAction } from 'shared/util/utility';
import { API_CONFIG } from 'shared/constants/constants';
import { LoginResponse, UserProfileResponse } from '../interface/login.interface';
import localizationConstants from 'shared/util/translation/constants';
import { refreshLanguage } from 'shared/util/localization';
import Button from 'shared/components/form/button';
import MenuService from 'shared/services/menu.service';

const MagicLoginHandler: React.FC = () => {
	const dispatch = useDispatch();
	const location = useLocation();
	const searchParams = new URLSearchParams(location.search);
	const token = searchParams.get('token');
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		if (!token) {
			setError('No token provided');
			return;
		}
        dispatch(createAction(actionTypes.AUTH_INIT));
		
		httpService.post(API_CONFIG.path.magicLoginVerify, { token }, {}, {
			isAccessTokenRequire: false
		})
        .then((response: LoginResponse) => {
			AuthService.setAuthData(response);

			httpService.get(API_CONFIG.path.profile).then((profileResponse: UserProfileResponse) => {
				profileResponse.sidebarMenu = MenuService.generateSidebarMenu(profileResponse);
				AuthService.setUserData(profileResponse);
				refreshLanguage(profileResponse.user.language || 'de');
				window.location.replace('/');
				dispatch(createAction(actionTypes.AUTH_SUCCESS, profileResponse));
			});
		})
        .catch((error) => {
			dispatch(createAction(actionTypes.AUTH_FAIL));
            let errorMessage = 'Invalid or expired magic link.';
			if (error && error.response && error.response.data && error.response.data.message) {
				errorMessage = error.response.data.message;
			}
			
			setError(errorMessage);
		});
	}, []);

	if (error) {
		return (
			<div style={{ 
				display: 'flex', 
				justifyContent: 'center', 
				alignItems: 'center', 
				height: '100vh',
				flexDirection: 'column'
			}}>
				<div style={{ color: 'red', marginBottom: '20px' }}>{error}</div>
                <Button btnType='primary' type='button' className='ml-1 mb-0' onClick={() => window.location.href = '/login'}>
                    {localizationConstants.goTologin}
                </Button>
			</div>
		);
	}

	return (
		<div style={{ 
			display: 'flex', 
			justifyContent: 'center', 
			alignItems: 'center', 
			height: '100vh',
			flexDirection: 'column'
		}}>
			<div>Verifying magic link...</div>
			<div style={{ marginTop: '20px' }}>
				<div>Loading...</div>
			</div>
		</div>
	);
};

export default MagicLoginHandler; 